import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowNext = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.3633 7L15.3633 12L10.3633 17",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgArrowNext;
